<script lang="ts">
	export let additionalClass = '';
</script>

<svg
	height="100%"
	fill="currentColor"
	version="1.1"
	viewBox="0 0 14 10"
	width="100%"
	fill-rule="evenodd"
	clip-rule="evenodd"
	class={additionalClass}
	><use xlink:href="#ytp-id-50" />
	<path
		d="M13.7064 0.293031C13.8939 0.480558 13.9992 0.734866 13.9992 1.00003C13.9992 1.26519 13.8939 1.5195 13.7064 1.70703L5.70643 9.70703C5.5189 9.8945 5.2646 9.99982 4.99943 9.99982C4.73427 9.99982 4.47996 9.8945 4.29243 9.70703L0.292431 5.70703C0.110272 5.51843 0.00947813 5.26583 0.0117566 5.00363C0.014035 4.74143 0.119204 4.49062 0.304612 4.30521C0.49002 4.1198 0.740832 4.01464 1.00303 4.01236C1.26523 4.01008 1.51783 4.11087 1.70643 4.29303L4.99943 7.58603L12.2924 0.293031C12.48 0.10556 12.7343 0.000244141 12.9994 0.000244141C13.2646 0.000244141 13.5189 0.10556 13.7064 0.293031Z"
	/>
</svg>
